var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 53,
    viewBox: "0 0 45 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8594 20.4707C35.2591 20.5686 37.6643 20.5984 40.0621 20.6508C40.6301 20.6631 41.2148 20.6806 41.7328 20.9009C43.2703 21.5567 43.4424 23.5205 43.385 25.1137C43.3203 26.9061 43.065 29.0134 41.4165 29.9C40.558 30.3634 39.5163 30.3634 38.5283 30.3512L7.75249 29.9874C6.61463 29.9734 5.68399 30.8391 5.68029 31.9128L5.60813 46.9206C5.60258 47.9244 5.67104 49.0786 6.51102 49.6924C7.05127 50.0876 7.77839 50.1488 8.4611 50.1908C18.082 50.7889 27.7362 50.8956 37.3683 50.5108C38.7929 50.4549 40.4414 50.2712 41.2074 49.1328C41.7069 48.3896 41.6718 47.4453 41.62 46.5656C41.3609 42.2165 41.1019 39.8312 40.8429 35.482",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1742 16.418C16.7515 17.7663 19.5989 18.7141 22.4741 19.3209C25.884 20.0396 29.3623 20.3282 32.8573 20.4716",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9063 6.16552C19.107 4.33457 16.0006 2.92158 12.7369 2.00523C11.0569 1.53307 9.16603 1.20955 7.61373 1.979C5.98373 2.78692 5.1715 4.66509 5.30471 6.4016C5.43792 8.13637 6.36671 9.73648 7.48977 11.1145C9.28814 13.3197 11.5972 15.0684 14.1745 16.4167",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0408 14.3242C28.889 13.6019 28.6226 12.8954 28.2692 12.2414C27.3996 10.6378 26.0453 9.31223 24.6003 8.13532C23.74 7.43407 22.8408 6.77828 21.9083 6.16797",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1136 13.4922C21.3366 14.3263 20.7131 15.2724 20.5669 16.3584C20.2764 18.5216 22.3505 20.6901 24.6576 20.6324C26.5652 20.5851 28.2562 19.1826 28.8705 17.4759C29.235 16.4633 29.2609 15.3756 29.0426 14.3246",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21694 25.6179C1.90796 24.7243 1.59343 23.8114 1.60823 22.8723C1.62303 21.9332 2.02637 20.9452 2.8682 20.4451C3.59162 20.0166 4.49821 20.0096 5.35299 20.0184C8.78877 20.0498 12.2227 20.0813 15.6585 20.1128C18.4596 20.139 20.9204 19.5899 23.6771 19.1632C30.9391 18.0388 38.3805 15.1009 42.2067 9.0764C42.5378 8.55352 42.6933 7.93621 42.5878 7.33464C42.2603 5.47396 39.9864 5.31657 38.251 5.57539C32.6357 6.41304 27.3016 8.86305 23.1332 12.5179C22.7817 12.8257 22.4357 13.151 22.1137 13.4955",
    stroke: "#F5CF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.0bb6804f2fe780e4dd5740f4ae9203a4.svg";
export { ForwardRef as ReactComponent };